'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMRadioButtonItem = require('./OMRadioButtonItem.scss');var styles = _interopRequireWildcard(_OMRadioButtonItem);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMRadioButtonItem = function OMRadioButtonItem(properties) {var _cx, _cx2;var
  element = properties.element,details = properties.details,_properties$params = properties.params,name = _properties$params.name,checked = _properties$params.checked,onChange = _properties$params.onChange,value = _properties$params.value,isAgent = _properties$params.isAgent,isMobile = _properties$params.isMobile,parameters = properties.parameters;
  return (
    _react2.default.createElement('div', _extends({
        className: (0, _classnames2.default)(
        properties.className,
        styles.packageWrapper, (_cx = {}, _cx[
        styles.checked] = checked, _cx), (_cx2 = {}, _cx2[
        styles.publisherPackageWrapper] = !isAgent, _cx2)) },

      parameters),

      _react2.default.createElement('label', { htmlFor: value, className: styles.packageHeader },
        _react2.default.createElement('div', { className: 'radio' },
          _react2.default.createElement('label', { htmlFor: value },
            _react2.default.createElement('input', {
              name: name,
              type: 'radio',
              value: value,
              id: value,
              checked: checked,
              onChange: onChange }),

            _react2.default.createElement('span', null),
            isMobile ?

            _react2.default.createElement('div', { className: styles.mobileContent },
              element.properties,
              element.highlight) :


            _react2.default.createElement('span', null, element.properties)),


          !isMobile && element.highlight),

        properties.children),

      checked && details));


};exports.default =

OMRadioButtonItem;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMRadioButtonItem/OMRadioButtonItem.js
// module id = 2729
// module chunks = 0